var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.description,
          expression: "description"
        }
      ],
      attrs: {
        placeholder:
          "Escreva instruções e cuidados para a limpeza, ou qualquer informação que achar necessária...",
        cols: "55",
        rows: "7"
      },
      domProps: { value: _vm.description },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.description = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "btn bg-pink mt-10",
        class: { "btn-disabled": _vm.cantSave() },
        on: {
          click: function($event) {
            _vm.save()
          }
        }
      },
      [_vm._v("salvar e avançar")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-392f8f9b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392f8f9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/CheckoutPopup/Description.vue
// module id = null
// module chunks = 